import axios from 'axios';

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/device-groups`;

const getDeviceGroups = async () => {
  const response = await axios.get(API_URL, { headers: getAuthHeader() });
  return response.data;
};

const createDeviceGroup = async (data) => {
  const response = await axios.post(API_URL, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }
  });
  return response.data;
};

const updateDeviceGroup = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }
  });
  return response.data;
};

const deleteDeviceGroup = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

const getDeviceGroup = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: getAuthHeader() });
  return response.data;
};

const getGroupMembers = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/members`, { headers: getAuthHeader() });
  return response.data;
};

const getGroupCandidates = async (id, { q, location } = {}) => {
  const params = {};
  if (q) params.q = q;
  if (location) params.location = location;
  const response = await axios.get(`${API_URL}/${id}/candidates`, {
    headers: getAuthHeader(),
    params,
  });
  return response.data;
};

const addGroupMembers = async (id, payload) => {
  const body = Array.isArray(payload)
    ? { registrationIds: payload }
    : {
        registrationIds: payload?.registrationIds || [],
        devices: payload?.devices || [],
      };
  const response = await axios.post(
    `${API_URL}/${id}/members`,
    body,
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const getDeviceAssignments = async (udid, serialNumber) => {
  const response = await axios.get(
    `${API_URL}/device/${encodeURIComponent(udid)}/assignments`,
    {
      headers: getAuthHeader(),
      params: serialNumber ? { serialNumber } : {},
    }
  );
  return response.data;
};

const setDeviceGroups = async (udid, payload) => {
  const response = await axios.put(
    `${API_URL}/device/${encodeURIComponent(udid)}/groups`,
    payload,
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const setDeviceDeclarations = async (udid, payload) => {
  const response = await axios.put(
    `${API_URL}/device/${encodeURIComponent(udid)}/declarations`,
    payload,
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const assignDeviceApp = async (udid, payload) => {
  const response = await axios.post(
    `${API_URL}/device/${encodeURIComponent(udid)}/apps`,
    payload,
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const removeGroupMembers = async (id, payload) => {
  const body = Array.isArray(payload)
    ? { registrationIds: payload }
    : {
        registrationIds: payload?.registrationIds || [],
        devices: payload?.devices || [],
      };
  const response = await axios.post(
    `${API_URL}/${id}/members/remove`,
    body,
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const removeGroupMember = async (id, registrationId) => {
  const response = await axios.delete(`${API_URL}/${id}/members/${registrationId}`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

const resyncGroupMember = async (id, registrationId) => {
  const response = await axios.post(
    `${API_URL}/${id}/members/${registrationId}/resync`,
    {},
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const deviceGroupService = {
  getDeviceGroups,
  getDeviceGroup,
  createDeviceGroup,
  updateDeviceGroup,
  deleteDeviceGroup,
  getGroupMembers,
  getGroupCandidates,
  addGroupMembers,
  removeGroupMembers,
  removeGroupMember,
  resyncGroupMember,
  getDeviceAssignments,
  setDeviceGroups,
  setDeviceDeclarations,
  assignDeviceApp,
};
export default deviceGroupService;
